<div class="slideout-content">
    <div class="modalsd modal-slide-in sdfade new-user-modal" id="modals-slide-in">
        <div class="modal-dialog">
            <form class="add-new-user modal-content pt-0">
                <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        (click)="toggleSidebar()"
                >
                    ×
                </button>
                <div class="modal-header">
                    <h5 class="modal-title" *ngIf="!data || !data['id']">Add Book</h5>
                    <h5 class="modal-title" *ngIf="data && data['id']">Update Book</h5>
                </div>
                <div class="modal-body flex-grow-1">
                    <form class="form mt-2 shadow-none" novalidate [formGroup]="addBookForm">
                        <div class="container">
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label>University</label>
                                        <select class="form-control" id="university_id" formControlName="university_id">
                                            <option value="">Select University</option>
                                            <option [value]="uni?.id"
                                                    *ngFor="let uni of universities">{{ uni.name }}
                                            </option>
                                        </select>
                                        <small *ngIf="submitted && addBookForm.get('university_id').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label>Course</label>
                                        <select class="form-control" id="course_id" formControlName="course_id">
                                            <option value="">Select Course</option>
                                            <option [value]="course?.id"
                                                    *ngFor="let course of courses">{{ course.name }}
                                            </option>
                                        </select>
                                        <small *ngIf="submitted && addBookForm.get('course_id').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label>Category</label>
                                        <select class="form-control" id="category_id" formControlName="category_id">
                                            <option value="">Select Category</option>
                                            <option [value]="cat?.id"
                                                    *ngFor="let cat of category">{{ cat.name }}
                                            </option>
                                        </select>
                                        <small *ngIf="submitted && addBookForm.get('category_id').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label>Semester</label>
                                        <select class="form-control" id="semester" formControlName="semester">
                                            <option value="">Select Semester</option>
                                            <option [value]="sem" *ngFor="let sem of semesters">{{ sem }}</option>
                                        </select>
                                        <small *ngIf="submitted && addBookForm.get('semester').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>


                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="name">Name</label>
                                        <input class="form-control" id="name" type="text" formControlName="name">
                                        <small *ngIf="submitted && addBookForm.get('name').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label>Upload Book (PDF)</label>

                                        <div class="d-flex align-items-center">

                                            <!-- Upload Button -->
                                            <button
                                                    type="button"
                                                    class="btn btn-primary mr-2"
                                                    (click)="bookUpload.click()">
                                                <i class="fas fa-cloud-upload-alt"></i> Upload
                                            </button>

                                            <!-- Eye Icon (shows after upload or in edit mode) -->
                                            <i
                                                    *ngIf="uploadedBookUrl"
                                                    class="fas fa-eye f_20 text-success cursor-pointer"
                                                    title="View Book"
                                                    (click)="openUploadedBook()"
                                            ></i>

                                        </div>

                                        <!-- Hidden File Input -->
                                        <input
                                                type="file"
                                                class="form-control-file d-none"
                                                accept="application/pdf"
                                                (change)="onBookFileChange($event, 'E_BOOK', data)"
                                                #bookUpload
                                        >
                                    </div>
                                </div>


                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <button rippleEffect type="button" class="btn btn-danger" data-dismiss="modal" aria-label="Close" (click)="toggleSidebar()"> cancel
                                    </button>
                                    <button type="submit" rippleEffect class="btn btn-primary ml-1 pull-right"
                                            (click)="submit()" *ngIf="!data || !data['id']">Submit
                                    </button>
                                    <button type="submit" rippleEffect class="btn btn-primary ml-1 pull-right"
                                            (click)="update()" *ngIf="data && data['id']">Update
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </form>
        </div>
    </div>
    <!-- Modal to add new user Ends-->
</div>
